import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "viewing-list-header" }
const _hoisted_2 = { class: "viewing-list-header__tabs" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "viewing-list" }
const _hoisted_7 = { class: "viewing-list__items" }
const _hoisted_8 = {
  key: 0,
  class: "viewing-list__side"
}
const _hoisted_9 = { class: "font-bold mb-4 mt-12 text-sky-500 border-b border-b-sky-700" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "font-bold mb-4 mt-12 text-sky-500 border-b border-b-sky-700" }
const _hoisted_12 = { class: "font-bold mb-4 mt-12 text-sky-500 border-b border-b-sky-700" }

import { computed, onMounted, ref } from 'vue'
    import { Viewing } from '@/interface'
    import ViewingCard from '@/components/ViewingCard.vue'
    import GoogleMaps from '@/components/ui/GoogleMaps.vue'
    import ViewingCardImage from '@/components/ViewingCard/ViewingCardImage.vue'
    import ViewingCardTitle from '@/components/ViewingCard/ViewingCardTitle.vue'
    import ImageGallery from '@/components/ui/ImageGallery.vue'
    import { useCustomerData } from '@/composables/customerData'
    import { useViewingsFilter } from '@/composables/viewingsFilter'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { viewings } = useCustomerData()
    const { selectedViewingsFilter } = useViewingsFilter()

    const activeViewing = ref<Viewing|null>(null)
    const filteredViewings = computed(() => {
        return viewings
            .slice(0)
            .sort((a, b) => a.date < b.date ? -1 : 1)
            .filter(v => {
                switch (selectedViewingsFilter.value) {
                case 'without-response': return v.response === null
                case 'with-response': return v.response !== null
                default: return true
                }
            })
    })

    const viewingImages = computed(() => {
        if (!activeViewing.value) {
            return []
        }

        return activeViewing.value?.media
            .slice(0, activeViewing.value?.media.length > 6 ? 6 : undefined)
            .filter(v => v.vrijgave)
            .filter(v => typeof v.linkToOriginal === 'string')
            .filter(v => ['HOOFDFOTO', 'FOTO'].includes(v.soort))
            .sort((a, b) => a.volgnummer < b.volgnummer ? -1 : 1)
            .map(v => v.linkToOriginal)
    })

    const allImages = computed(() => {
        if (!activeViewing.value) {
            return []
        }

        return activeViewing.value?.media
            .slice(0)
            .filter(v => v.vrijgave)
            .filter(v => typeof v.linkToOriginal === 'string')
            .sort((a, b) => a.volgnummer < b.volgnummer ? -1 : 1)
            .map(v => v.linkToOriginal)
    })

    const relatieAddress = computed(() => {
        if (!activeViewing.value) {
            return ''
        }

        return `${activeViewing.value?.relatie.adresgegevens.huisadres.huisadresRegel1} ${activeViewing.value?.relatie.adresgegevens.huisadres.huisadresHuisnummer} ${activeViewing.value?.relatie.adresgegevens.huisadres.huisadresHuisnummertoevoeging}, ${activeViewing.value?.relatie.adresgegevens.huisadres.huisadresPlaats}`
    })

    const propertyAddress = computed(() => {
        return `${activeViewing.value?.adres.straat} ${activeViewing.value?.adres.huisnummer} ${activeViewing.value?.adres.huisnummertoevoeging}, ${activeViewing.value?.adres.plaats}`
    })

    const hasViewingsWithoutResponse = computed(() => {
        return viewings.filter(v => v.response === null).length > 0
    })

    const hasViewingsWithResponse = computed(() => {
        return viewings.filter(v => v.response !== null).length > 0
    })

    onMounted(() => {
        // @todo: sidebar is disabled until further notice

        // const nextViewings = viewings
        //     .filter(v => v.date > new Date())
        //     .sort((a, b) => a.date < b.date ? -1 : 1)

        // if (nextViewings.length > 0) {
        //     activeViewing.value = nextViewings[0]
        // }

        // select correct filtering
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass({active: _unref(selectedViewingsFilter) === 'all'}),
          textContent: _toDisplayString(_ctx.$t('viewing.filter.all')),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedViewingsFilter.value = 'all'))
        }, null, 10, _hoisted_3),
        (_unref(hasViewingsWithoutResponse))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({active: _unref(selectedViewingsFilter) === 'without-response'}),
              textContent: _toDisplayString(_ctx.$t('viewing.filter.withoutResponse')),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedViewingsFilter.value = 'without-response'))
            }, null, 10, _hoisted_4))
          : _createCommentVNode("", true),
        (_unref(hasViewingsWithResponse))
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass({active: _unref(selectedViewingsFilter) === 'with-response'}),
              textContent: _toDisplayString(_ctx.$t('viewing.filter.withResponse')),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedViewingsFilter.value = 'with-response'))
            }, null, 10, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredViewings), (viewing) => {
          return (_openBlock(), _createBlock(ViewingCard, {
            class: _normalizeClass({active: (viewing.id === activeViewing.value?.id)}),
            key: viewing.id,
            viewing: viewing
          }, null, 8, ["class", "viewing"]))
        }), 128))
      ]),
      (activeViewing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createVNode(ViewingCardImage, { images: _unref(viewingImages) }, null, 8, ["images"]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('viewing.nextAppointment')), 1),
              _createVNode(ViewingCardTitle, {
                class: "scale-75 origin-top-left",
                style: {"text-align":"left !important"},
                date: activeViewing.value.date
              }, null, 8, ["date"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, _toDisplayString(activeViewing.value.adres.straat), 1),
                _createElementVNode("div", null, _toDisplayString(activeViewing.value.adres.postcode) + ", " + _toDisplayString(activeViewing.value.adres.plaats), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('viewing.routeToProperty')), 1),
            _createVNode(GoogleMaps, {
              class: "h-96 rounded-xl",
              origin: _unref(propertyAddress),
              destination: _unref(relatieAddress)
            }, null, 8, ["origin", "destination"]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('viewing.images')), 1),
            _createVNode(ImageGallery, { images: _unref(allImages) }, null, 8, ["images"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})